import { initTheme } from "./ThemeBuilder";
if(typeof window !== "undefined"){
    if(!window.FR) window.FR = {};
    window.FR.initTheme=initTheme;
}